import axiosInstance from "../axiosInstance";

export const channelInventoryService = {
  fetch: async (query = "", signal) => {
    try {
      let api = `/product-channel-inventory?`;

      if (!query.includes("$sort")) {
        api += `&$sort[updatedAt]=-1`;
      }

      if (query && query.length) api += `&${query}`;

      const response = await axiosInstance.get(
        api,
        signal ? { signal } : undefined,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (id, obj) => {
    try {
      const response = await axiosInstance.patch(
        `product-channel-inventory/${id}`,
        obj,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Distinct CHANNEL values for the column filter. These are upstream source
  // names (Pipe17 locations) that live only on the inventory rows themselves —
  // unlike `provider`, there is no collection of them to look up — so the
  // options are derived by deduping the rows client-side.
  fetchSourceChannels: async (
    searchKey = "",
    client_id,
    limit = 15,
    skip = 0,
  ) => {
    try {
      let api = `/product-channel-inventory?$limit=200&$select[]=source_channel&$select[]=provider`;
      if (client_id) api += `&client_id=${client_id}`;
      if (searchKey)
        api += `&source_channel[$regex]=${encodeURIComponent(searchKey)}&source_channel[$options]=i`;
      const response = await axiosInstance.get(api);
      const seen = new Map();
      for (const row of response.data?.data || []) {
        const name = row.source_channel || row.provider;
        if (name && !seen.has(name)) seen.set(name, { _id: name, name });
      }
      const all = [...seen.values()];
      // `skip` is an absolute offset (matches every other paginated service in
      // this app, and what AutocompleteWithPagination passes in), not a page
      // number.
      return {
        data: all.slice(skip, skip + limit),
        total: all.length,
      };
    } catch (error) {
      throw error;
    }
  },

  fetchForecastHistory: async (client_id, sku) => {
    try {
      const response = await axiosInstance.get(
        `/forecast-data?$sort[createdAt]=-1&forecast_type=channel&client=${client_id}&sku=${encodeURIComponent(
          sku,
        )}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
